"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButtonSizes = void 0;
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const elements_ui_configs_1 = require("@hydrogen/elements.ui.configs");
const themes_1 = require("./themes");
var LinkButtonSizes;
(function (LinkButtonSizes) {
    LinkButtonSizes["default"] = "default";
    LinkButtonSizes["small"] = "small";
    LinkButtonSizes["large"] = "large";
})(LinkButtonSizes = exports.LinkButtonSizes || (exports.LinkButtonSizes = {}));
function LinkButton(props) {
    const Link = (0, elements_ui_configs_1.getLink)();
    const TagName = props.as || 'button';
    const buttonType = TagName === 'button'
        ? props.htmlType || 'button'
        : undefined;
    const size = props.size || 'default';
    const sizeClasses = (0, elements_ui_utils_1.classNames)(themes_1.theme.sizes[size].text);
    const focusClasses = (0, elements_ui_utils_1.classNames)(themes_1.theme.states.focus.layer);
    const disabledClasses = props.disabled ? (0, elements_ui_utils_1.classNames)(themes_1.theme.states.disabled.layer) : '';
    const combinedClasses = (0, elements_ui_utils_1.classNames)(themes_1.theme.shared, themes_1.theme.types.default.layer, themes_1.theme.types.default.text, sizeClasses, focusClasses, disabledClasses, props.className);
    if (TagName === 'a' && props.href) {
        return (react_1.default.createElement(Link, Object.assign({ to: props.href, type: buttonType, className: combinedClasses, disabled: props.disabled }, props), props.children));
    }
    return (react_1.default.createElement(TagName, Object.assign({ type: buttonType, className: combinedClasses, disabled: props.disabled }, props), props.children));
}
exports.default = LinkButton;
//# sourceMappingURL=link-button.js.map